(ns motorsaif.web.pages.new-business
  (:require
   [motorsaif.time :as time]
   [clojure.string :as str]
   [reagent.core :as r]
   [motorsaif.validation :as validation]
   [motorsaif.web.forms.business :as business-form]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.string :refer [format]]
   [re-frame.core :as rf :refer [dispatch subscribe]]))

(defn root []
  (let [user @(subscribe [:user])
        init-data {:business {}}
        form-key :new-business
        on-submit (fn [{:keys [new-data]}]
                    (let [new-data (-> (update-in new-data [:business :business/media] #(vec (remove nil? %))))
                          req {:type :POST
                               :url "/api/businesses"
                               :params {:data new-data}
                               :id :new-business
                               :handler
                               (fn [{:keys [success ex-message] :as res}]
                                 (if success
                                   (do (rf/dispatch [:toast {:type "success"
                                                             :message "Business created! Reloading..."}])
                                       (rf/dispatch [:common/navigate! :admin-table {:table :businesses}])
                                       (js/setTimeout (fn []
                                                        (js/window.location.reload))
                                                      500))
                                   (rf/dispatch
                                    [:toast {:type "error"
                                             :message (format "Failed to saved %s: " ex-message)}])))
                               :error-handler (fn [res]
                                                (println "Error creating"))}]
                      (rf/dispatch [:do-ajax req])))

        make-form-args
        {:schema validation/new-business
         :change-watch #(dispatch [:reset-form form-key %])
         :on-submit {:valid on-submit
                     :invalid (fn [error]
                                (let [error-titles ((:error-titles-fn error) :new-business)]
                                  (rf/dispatch [:toast {:type "error"
                                                        :timeout 5000
                                                        :title "Please fix below issues"
                                                        :message (str/join ", " error-titles)}]))
                                (println "Submit error " error))}
         :init-data init-data}]
    [:div.content.container
     [:h1 "New Business"]
     [:div.wrap
      [:div.container.md
       [:div.round.light
        [business-form/form
         {:form-key form-key
          :make-form-args make-form-args}]]]]]))
